export default __webpack_public_path__ + "static/media/cloud-icon.4d2d6605.png";